import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
    import { ValidationRule } from '@/model/types'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FormInput',
  props: {
        modelValue: [String, Number, Object],
        rules: {
            type: Array as () => ValidationRule[] | undefined, // Updated type
            default: undefined,
        },
        label: String,
        required: Boolean,
        disabled: Boolean,
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

    const props = __props

    const emit = __emit

    const inputValue = computed({
        get: () => props.modelValue,
        set: (val) => emit('update:modelValue', val),
    })

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, {
    class: "p-[5px]",
    style: {"width":"33.3333%","display":"inline-block"},
    rules: props.rules,
    label: props.label,
    required: props.required,
    disabled: props.disabled,
    modelValue: inputValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event))
  }, null, 8, ["rules", "label", "required", "disabled", "modelValue"]))
}
}

})